import { Component, OnInit } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import firebase from 'firebase/compat/app';

@Component({
  selector: 'app-failed-payments-management',
  templateUrl: './failed-payments-management.component.html',
  styleUrls: ['./failed-payments-management.component.css']
})
export class FailedPaymentsManagementComponent implements OnInit {
  activeTab: 'retiros' | 'transferencias' = 'retiros';
  filteredRetiros: any[] = [];
  filteredTransferencias: any[] = [];
  allPayouts: any[] = [];
  allTransfers: any[] = [];

  constructor(private afs: AngularFirestore) {}

  ngOnInit(): void {
    this.fetchFailedPayments();
  }

  fetchFailedPayments(filters?: any) {
    // Payouts (snapshot para obtener IDs)
    this.afs
      .collection('withdraws-mangopay', ref => ref.where('section', '==', 'payout'))
      .snapshotChanges()
      .subscribe((snaps: any[]) => {
        this.allPayouts = snaps.map(s => ({ id: s.payload.doc.id, ...(s.payload.doc.data() as any) }));
        this.applyFilters(filters);
      });

    // Transferencias (snapshot para obtener IDs)
    this.afs
      .collection('withdraws-mangopay', ref => ref.where('section', '==', 'transfer'))
      .snapshotChanges()
      .subscribe((snaps: any[]) => {
        this.allTransfers = snaps.map(s => ({ id: s.payload.doc.id, ...(s.payload.doc.data() as any) }));
        this.applyFilters(filters);
      });
  }

  onFilterChange(filters: any) {
    this.applyFilters(filters);
  }

  markAsProcessed(item: any) {
    if (!item?.id) return;
    if (item.status === 'processed') return; // ya marcado
    this.afs.collection('withdraws-mangopay').doc(item.id).update({
      status: 'processed',
      processedAt: firebase.firestore.FieldValue.serverTimestamp()
    });
  }

  applyFilters(filters: any) {
    const f = filters || {};
    const baseFilter = (arr: any[]) => arr.filter(item => {
      const ts = item?.date?.seconds ? new Date(item.date.seconds * 1000) : new Date(item.date);
      const emailMatch = !f.email || item.userEmail?.toLowerCase().includes(f.email.toLowerCase());
      const minAmountMatch = !f.minAmount || item.amount >= f.minAmount;
      const maxAmountMatch = !f.maxAmount || item.amount <= f.maxAmount;
      const dateFromMatch = !f.dateFrom || ts >= new Date(f.dateFrom);
      const dateToMatch = !f.dateTo || ts <= new Date(f.dateTo);
      const status = (item.status || '').toLowerCase();
      const statusMatch = (
        (f.statusFailed && status === 'failed') ||
        (f.statusProcessed && (status === 'processed' || status === 'success' || status === 'succeeded'))
      );
      return emailMatch && minAmountMatch && maxAmountMatch && dateFromMatch && dateToMatch && statusMatch;
    });

  const retiros = this.allPayouts || [];
  const transferencias = this.allTransfers || [];

  if (!filters) {
      this.filteredRetiros = retiros;
      this.filteredTransferencias = transferencias;
      return;
    }
  this.filteredRetiros = baseFilter(retiros);
  this.filteredTransferencias = baseFilter(transferencias);
  }
}
